import React, { PureComponent } from 'react';
import { Link } from 'react-router-dom';
import Moment from 'react-moment';
import { Table } from 'reactstrap';
import { connect } from 'react-redux';
import { object, bool } from 'prop-types';
import DateTime from '../../../../components/DateTime/DateTime';
import { createMarkup } from '../../../../utils/utils';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { STATIC_PATH } from '../../../../config';
import Icon from '../../../../components/Icon/Icon';
import Card from '../../../../components/Card/Card';
import { startSetNews } from '../../../../actions/news';

class NewsListItem extends PureComponent {
  static propTypes = {
    news: object.isRequired,
    groupByDate: bool,
    inOffer: bool,
  };

  static defaultProps = {
    news: {},
    changeDate: false,
  };
  state = {
    hideNewsText: true,
    news: {},
  };

  renderNewsText = ({ news, offerId, offerTitle }) => {
    return (
      <div className="news-text">
        <span dangerouslySetInnerHTML={createMarkup(news.text)} />
        {offerId && (
          <span>
            <Link to={`/offers/${offerId}/`}>{offerTitle}</Link>
          </span>
        )}
      </div>
    );
  };

  getPossibleOfferLink = news => {
    const regExpOffer = /<a[^>]+href=['"]?[^'" ]*?\/offers\/(\d+)[^'" ]*?[^>]*>(.*?)<\/a>/gi;
    const preparedNews = { ...news };
    const match = regExpOffer.exec(preparedNews.text);
    let text;
    let offerId;
    let offerTitle;
    if (match && match[0] && match[1] && match[2]) {
      text = preparedNews.text.replace(match[0], '');
      offerId = match[1];
      offerTitle = match[2];
    }
    return {
      news: {
        ...preparedNews,
        text: match ? text : preparedNews.text,
      },
      offerId,
      offerTitle,
    };
  };

  getIconType = (type = 0) => {
    switch (type) {
      case 0:
      case 3:
      case 4:
      case 5:
      case 8:
      case 9:
      case 10:
      case 11:
      case 12:
        return 'refresh';
      case 2:
      case 6:
        return 'pause-offer';
      case 1:
        return 'new-offer';
      case 7:
        return 'boost';
      default:
        return 'refresh';
    }
  };

  getIconColor = (type = 0) => {
    switch (type) {
      // case 0:
      // case 7:
      //   return 'purple';
      // case 1:
      // case 3:
      //   return 'blue';
      // case 2:
      //   return 'dark-orange';
      // case 4:
      // case 5:
      //   return 'light-blue';
      // case 6:
      // case 10:
      //   return 'gray';
      // case 8:
      // case 9:
      // case 12:
      //   return 'green';
      // case 11:
      //   return 'orange';
      case 1:
        return 'green';

      case 7:
        return 'blue';
      case 0:
      case 3:
      case 4:
      case 5:
      case 8:
      case 9:
      case 10:
      case 11:
      case 12:
        return 'light-green';
      case 2:
      case 6:
        return 'orange';
      default:
        return 'light-green';
    }
  };

  toggleNewsText = (e, newsId) => {
    this.props.setNews(newsId).then(({ news: { text } }) => {
      this.setState(prevState => ({
        hideNewsText: !prevState.hideNewsText,
        news: {
          ...prevState.news,
          [newsId]: text,
        },
      }));
    });
  };

  render() {
    const { groupByDate, inOffer } = this.props;
    const { news, offerId, offerTitle } = this.getPossibleOfferLink(this.props.news);

    return (
      <div className="news-item">
        {groupByDate && news.changeDate && (
          <Moment element="h3" format="DD MMMM" unix>
            {news.its}
          </Moment>
        )}
        <Table>
          <tbody>
            <tr>
              <td className="news-time">
                <Moment element="ins" format="LT" unix>
                  {news.its}
                </Moment>
              </td>
              <td className={`news-title-wrapper ${this.getIconColor(news.type)}`}>
                <img src={`${STATIC_PATH}/img/news-icons/${this.getIconType(news.type)}.svg`} />
                <span onClick={e => this.toggleNewsText(e, news.id)}>{news.title}</span>
              </td>
            </tr>
            <tr
              className="news-text-row"
              style={{ display: this.state.hideNewsText ? 'none' : 'table-row' }}
            >
              <td></td>
              <td className="news-text-data">
                {this.state.news[news.id] && (
                  <div
                    className="news-text"
                    dangerouslySetInnerHTML={createMarkup(this.state.news[news.id])}
                  />
                )}
              </td>
            </tr>
          </tbody>
        </Table>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  setNews: newsId => dispatch(startSetNews(newsId)),
});

export default connect(
  undefined,
  mapDispatchToProps,
)(NewsListItem);
